/**
 * A hivas-ertesitesek eltakaritasa (K2).
 *
 * A bejovo hivasrol a service worker ismetlodo, el nem tuno ertesitest
 * mutat (lasd `sw.js`, `csengess`). Ha a hivast az appban vettek fel,
 * utasitottak el, vagy a hivo letette, az ertesitesnek is el kell tunnie -
 * kulonben a fiokban ott marad egy "Bejovo hivas", amit mar nem lehet
 * felvenni, es a telefon tovabb rezeg miatta.
 */
export function closeCallNotifications(channelId: string): void {
  if (typeof navigator === 'undefined' || !navigator.serviceWorker) return;
  void navigator.serviceWorker.ready
    .then(async (registration) => {
      const notifications = await registration.getNotifications();
      for (const notification of notifications) {
        const data = notification.data as { kind?: string; channelId?: string } | null;
        if (data?.kind === 'call' && data.channelId === channelId) notification.close();
      }
    })
    .catch(() => undefined);
}
